import { Col, Row } from "react-bootstrap";
import SettlementWarning from "../components/SettlementWarning";
import TabContainerWithTabs from "../components/TabContainer";
import { HouseholdsTable } from "../clients/household/Households";
import DashboardNav from "./DashboardNav";

const ClientSummary = () => (
  <TabContainerWithTabs tabs={DashboardNav}>
    <Row className="mb-3">
      <Col>
        <SettlementWarning />
      </Col>
    </Row>
    <Row>
      <Col>
        <HouseholdsTable />
      </Col>
    </Row>
  </TabContainerWithTabs>
);

export default ClientSummary;
